import _objectSpread from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import { createMuiTheme } from "@material-ui/core/styles";
import "typeface-roboto"; //Limitless imports

import { customerBackground } from "@limitless/images";
import { COMMON_PALETTE } from "../../common/utils/CommonPalette";
/**
 * The Theme class overrides the default theme from Material UI
 *
 * The variable velow represents all of our overrides.
 *
 * A full list of variables that can be overriden can be found here and in ./MaterialDefaults.json
 * https://material-ui-next.com/customization/themes/#the-other-variables
 *  contrastText
 */

var defaultTheme = {
  palette: _objectSpread({}, COMMON_PALETTE, {
    contrast: {
      light: "#fafafa",
      main: "#616161",
      text: "#616161"
    },
    dialogues: _objectSpread({}, COMMON_PALETTE.dialogues, {
      expert: {
        background: "#0A2267",
        text: "#fff",
        borderRadius: 10
      },
      suggestedAnswer: {
        background: "#0A2267",
        text: "#fff",
        borderRadius: 10
      }
    })
  }),
  background: {
    default: "#fafafa",
    paper: "#fff",
    appBar: "#f5f5f5",
    contentFrame: "#eeeeee",
    image: customerBackground
  },
  typography: {
    htmlFontSize: 16,
    fontFamily: "'Roboto', Helvetica, Arial, sans-serif",
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500
  },
  overrides: {
    MuiTab: {
      root: {
        padding: "initial"
      }
    },
    MuiButton: {
      root: {
        textTransform: "none",
        borderRadius: 30
      }
    },
    MuiIconButton: {
      root: {
        borderRadius: 0
      }
    }
  }
};
var typographyOverride = {
  props: {
    MuiTypography: {
      variant: "body2"
    }
  }
};
/**
 * Create a theme with a value from the platform if available.
 *
 * Fallback to the default built-in theme
 *
 * @param {object} theme
 */

export var createTheme = function createTheme(theme) {
  if (theme === {} || !theme) {
    var customerTheme = createMuiTheme(_objectSpread({}, defaultTheme, {}, typographyOverride));
    return customerTheme;
  }

  try {
    if (theme.typography.htmlFontSize === "auto") {
      var detectedFontSize = window.getComputedStyle(document.getElementsByTagName("html")[0]).getPropertyValue("font-size");
      detectedFontSize = detectedFontSize.replace("px", "");
      theme.typography.htmlFontSize = Number(detectedFontSize);
    }
  } catch (error) {
    //eslint-disable-next-line
    console.warn("Failed to auto detect font size, reverting to 16");
    theme.typography.htmlFontSize = 16;
  }

  return createMuiTheme(_objectSpread({}, theme, {}, typographyOverride));
};
/**
 * Create a basic Theme object that will be stored in S3 and then used by the above.
 */

export var createLimitlessCustomerTheme = function createLimitlessCustomerTheme() {
  var theme = _objectSpread({}, defaultTheme, {}, typographyOverride);

  return theme;
};